// vairable themeDir should be defined globally

const Image = React.forwardRef(({ 
    src, 
    title = undefined, 
    fallbackImage = undefined, 
    className = undefined, 
    errorClassName = 'error', 
    errorStyle = {}, 
    style = {}, 
    hideOnError = false,
    ...restProps 
}, ref) => {
    const [error, setError] = React.useState(!src)

    if (fallbackImage === undefined)
        fallbackImage = themeDir + "/images/no-image.svg"

    React.useEffect(() => {
        setError(!src)
    }, [src])

    function handleImageError({ currentTarget: img }) {
        if (!error) {
            img.onerror = null;
            img.src = fallbackImage;
            setError(true);
        }
    }

    if (error && hideOnError)
        return

    return (
        <img ref={ref}
            src={src}
            className={cn(className, error && errorClassName)}
            onError={handleImageError}
            alt=""
            title={title}
            style={Object.assign({}, style, error && errorStyle)}
            {...restProps}
        />
    )
})

export default Image
